export default class Media {
  alt: string;
  description: string;
  fileName: string;
  height: string;
  src: string;
  title: string;
  type: string;
  width: string;

  constructor(props: any) {
    // console.log('props: ', props);
    const { title, description, fileName, height, width, contentType, url } =
      props || {};

    this.alt = description || title || fileName;
    this.description = description;
    this.fileName = fileName;
    this.height = height;
    this.src = url;
    this.title = title;
    this.type = contentType;
    this.width = width;
  }

  isVideo() {
    return this.type && this.type.includes('video');
  }

  isImage() {
    return this.type && this.type.includes('image');
  }
}
